<template>
  <div class="step">
    <el-button type="primary" plain icon="el-icon-plus" @click="handleAdd" size="small">新建</el-button>
    <!-- <el-button type="success" plain size="small" icon="el-icon-edit" :disabled="ids.length == 1" @click="handleEdit">编辑</el-button> -->
    <el-button type="danger" plain size="small" icon="el-icon-delete" :disabled="ids.length == 0" @click="handleDel">删除</el-button>
    <el-button type="success" plain size="small" icon="el-icon-sort" @click="handleUpdate">更新排序</el-button>
    <el-table
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      @selection-change="handleSelectionChange"
      :header-cell-style="{ background: '#F9F9FB', color: '#606266' }"
      v-loading="loading"
      ref="dragTable"
      row-key="cfAppStepId"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column prop="order" label="顺序" width="60"></el-table-column>
      <el-table-column prop="cfappunitstepName" label="审批步骤" ></el-table-column>
      <el-table-column prop="ofrresourceNames" label="审批岗位" >
      </el-table-column>
      <el-table-column prop="stepFlowType" label="审批类型">
        <template slot-scope="scope">
          <DictTag :options="dropDown.stepFlowType" :value="scope.row.stepFlowType"/>
        </template>
      </el-table-column>
      <el-table-column prop="stepType" label="步骤类型">
        <template slot-scope="scope">
          <DictTag :options="dropDown.stepType" :value="scope.row.steptype"/>
        </template>
      </el-table-column>
      <el-table-column prop="controlShow" label="控制显示" align="center">
        <template slot-scope="scope">
          {{scope.row.controlShow == '1' ? '是': '否'}}
        </template>
      </el-table-column>
      <el-table-column prop="condType" label="条件类型">
        <template slot-scope="scope">
          <DictTag :options="dropDown.appCondType" :value="scope.row.condType"/>
        </template>
      </el-table-column>
      <el-table-column prop="startThan" label="开始条件">
        <template slot-scope="scope">
          <div style="display:flex">
            <DictTag :options="dropDown.appCondThan" :value="scope.row.startThan"/>
            {{scope.row.condStart}}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="endThan" label="结束条件">
        <template slot-scope="scope">
          <div style="display:flex">
            <DictTag :options="dropDown.appCondThan" :value="scope.row.endThan"/>
            {{scope.row.condEnd}}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="120">
        <template slot-scope="scope">
          <el-button
            size="mini"
            icon="el-icon-edit"
            type="text"
            @click.native.stop="handleEdit(scope.row)"
          >编辑
          </el-button>
          <el-button
            size="mini"
            icon="el-icon-delete"
            type="text"
            @click.native.stop="handleDel(scope.row)"
          >删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog v-dialog-drag
      :title="title"
      :visible.sync="dialogFormVisible"
      :append-to-body="true"
      width="30%"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="80px"
        class="demo-ruleForm"
        label-position="left"
        size="mini"
      >
        <el-form-item label="步骤" prop="cfappunitstepId">
          <el-select v-model="ruleForm.cfappunitstepId" placeholder="请选择审批步骤" style="width:100%" filterable>
            <el-option v-for="(item, index) in CfAppUsList" :key="index" :label="item.name" :value="item.cfAppUnitstepId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审批类型" prop="stepFlowType">
          <el-select v-model="ruleForm.stepFlowType" placeholder="请选择审批类型" style="width:100%" filterable>
            <el-option v-for="(item, index) in dropDown.stepFlowType" :key="index" :label="item.dictLabel" :value="item.dictValue"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="顺序" prop="order">
          <el-input-number v-model="ruleForm.order" controls-position="right" :min="1" type="number" style="width: 100%"></el-input-number>
        </el-form-item>
        <el-form-item label="控制显示" prop="controlShow">
          <el-radio v-model="ruleForm.controlShow" label="1">是</el-radio>
          <el-radio v-model="ruleForm.controlShow" label="0">否</el-radio>
        </el-form-item>
        <el-form-item label="条件类型" prop="condType">
          <el-select v-model="ruleForm.condType" placeholder="请选择条件类型" style="width:100%" filterable clearable>
            <el-option v-for="(item, index) in dropDown.appCondType" :key="index" :label="item.dictLabel" :value="item.dictValue"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开始条件" prop="startThan">
          <el-select v-model="ruleForm.startThan" placeholder="请选择比较类型" style="width:calc(100% / 2 - 16px);margin-right: 16px" filterable clearable>
            <el-option v-for="(item, index) in dropDown.appCondThan" :key="index" :label="item.dictLabel" :value="item.dictValue"></el-option>
          </el-select>
          <el-input v-model="ruleForm.condStart" style="width:calc(100% / 2)" clearable />
        </el-form-item>
        <el-form-item label="结束条件" prop="endThan">
          <el-select v-model="ruleForm.endThan" placeholder="请选择比较类型" style="width:calc(100% / 2 - 16px);margin-right: 16px" filterable clearable>
            <el-option v-for="(item, index) in dropDown.appCondThan" :key="index" :label="item.dictLabel" :value="item.dictValue"></el-option>
          </el-select>
          <el-input v-model="ruleForm.condEnd" style="width:calc(100% / 2)" clearable />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" :loading="isLoading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import url from '@/config/url'
import qs from 'qs'
import DictTag from '@/components/DictTag.vue'
import {mapState} from 'vuex'
import Sortable from 'sortablejs'
  export default {
    computed: {
      ...mapState({
        dropDown: (state) => state.dropDown.dropDown
      })
    },
    components: {
      DictTag,
    },
    props: {
      cfappId: [String, Number],
    },
    data() {
      return {
        // cfappId: this.$route.params.cfAppId,
        stepData: {},
        tableData: [],
        loading: false,
        dialogFormVisible: false,
        ruleForm: {
          cfappunitstepId: '',
          cfappId: this.cfappId,
          order: 1,
          controlShow: ''
        },
        rules: {
          cfappunitstepId: [{ required: true, message: "请选择审批步骤", trigger: "submit" }],
          stepFlowType: [{ required: true, message: "请选择审批类型", trigger: "submit" }],
          order: [{ required: true, message: "请选择顺序", trigger: "submit" }]
        },
        isLoading: false,
        CfAppUsList: [],
        ids: [],
        title: ''
      }
    },
    created () {
      this.tableData.forEach((item, index) => {
        item.index = index
      })
      if(this.cfappId) {
        this.ruleForm.cfappId = this.cfappId
        this.getList()
      }
      this.getData()
    },
    mounted() {
      const el = this.$refs.dragTable.$el.querySelectorAll(".el-table__body-wrapper > table > tbody")[0];
      const sortable = Sortable.create(el, {
        onEnd: evt => {
          const targetRow = this.tableData.splice(evt.oldIndex, 1)[0];
          this.tableData.splice(evt.newIndex, 0, targetRow);
          for (let index in this.tableData) {
            this.tableData[index].order = parseInt(index) + 1;
          }
        }
      });


      // this.getData();
      // this.getList()
    },
    methods: {
      getData() {
        this.$http.get(url.getAllCfAppUsList).then(res => {
          if(res.data.code == 200) {
            this.CfAppUsList = res.data.data
          }
        })

      },
      getList() {
        this.$http.get(url.getStepList, {params: {cfappId: this.cfappId}}).then(res => {
          if(res.data.code == 200) {
            this.tableData = res.data.data
          }
        })
        // 步骤类型下拉
        if(!this.dropDown.stepType) {
          this.$http.get(url.getDataList, {params: {type: 'buss_step_type' }}).then(res => {
            if(res.data.code == 200) {
              this.$store.commit('setStepType', res.data.data)
            }
          })
        }
        // 审批步骤条件类型下拉
        if(!this.dropDown.appCondType) {
          this.$http.get(url.getDataList, {params: {type: 'buss_app_cond_type' }}).then(res => {
            if(res.data.code == 200) {
              this.$store.commit('setAppCondType', res.data.data)
            }
          })
        }
        // 审批步骤条件比较下拉
        if(!this.dropDown.appCondThan) {
          this.$http.get(url.getDataList, {params: {type: 'buss_app_cond_than' }}).then(res => {
            if(res.data.code == 200) {
              this.$store.commit('setAppCondThan', res.data.data)
            }
          })
        }
        // 审批类型下拉
        if(!this.dropDown.stepFlowType) {
          this.$http.get(url.getDataList, {params: {type: 'buss_step_flow_type' }}).then(res => {
            if(res.data.code == 200) {
              this.$store.commit('setStepFlowType', res.data.data)
            }
          })
        }
      },
      // 提交表单
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.isLoading = true
            if(!this.ruleForm.cfAppStepId) {
              // 新增审批步骤
              this.$http.post(url.addStep, qs.stringify(this.ruleForm)).then(res => {
                // console.log(res);
                this.isLoading = false
                if(res.data.code === 200) {
                  this.$message.success(res.data.msg);
                  this.dialogFormVisible = false;
                  this.getList()
                }
              })
            }else {
              // 修改审批步骤
              this.$http.post(url.editStep, qs.stringify(this.ruleForm)).then(res => {
                // console.log(res);
                this.isLoading = false
                if(res.data.code === 200) {
                  this.$message.success(res.data.msg);
                  this.dialogFormVisible = false;
                  this.getList()
                }
              })
            }

          } else {
            return false;
          }
        });
      },
      handleAdd() {
        this.dialogFormVisible = true
        this.title = '新增步骤'
        this.$nextTick(() => {
        // 清除表单校验效果
          this.$refs.ruleForm.clearValidate();
        })
        // 初始化表单内容
        for(let key in this.ruleForm) {
          this.ruleForm[key] = null
        }
        this.ruleForm.order = this.tableData.length + 1
        this.ruleForm.cfappId = this.cfappId
        this.ruleForm.stepFlowType = '1'
      },
      handleEdit(row) {
        this.ruleForm = Object.assign({}, row)
        this.title = "编辑步骤"
        this.dialogFormVisible = true
        this.$nextTick(() => {
        // 清除表单校验效果
          this.$refs.ruleForm.clearValidate();
        })
      },
      handleDel(row) {
        // console.log(row);
        let cfAppStepIds = row.cfAppStepId || this.ids.toString()
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.post(url.removeStep, qs.stringify({cfAppStepIds})).then(res => {
            if(res.data.code === 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.getList()
            }
          })

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      handleUpdate() {
        this.$confirm('此操作将更新排序, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.post(url.updateStepSort, this.tableData).then(res => {
            if(res.data.code === 200) {
              this.$message({
                type: 'success',
                message: '更新成功!'
              });
              this.getList()
            }
          })

        }).catch(() => {
        });
      },
      handleSelectionChange(rows) {
        this.ids = rows.map(item => item.cfAppStepId)
      }
    },
    watch: {
      cfappId(newValue, oldValue) {
        // console.log(newValue);
        if(newValue) {
          this.ruleForm.cfappId = newValue
          this.getList()
        }

      }
    },
  }
</script>

<style lang="scss" scoped>
.step {
  .el-table {
    margin-top: 16px;
  }
}
</style>
